module.exports = __webpack_public_path__ + "img/52.abd9771f.jpg";